import "./JoinUs.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MembershipOpportunities from "./sections/MembershipOpportunities";
import PartnershipInquiry from "./sections/PartnershipInquiry";
import CommonQuestions from "./sections/CommonQuestions";
import FooterInformation from "@/reusable_sections/Footer";
export default function JoinUsPage() {
  return <div>
      <MainNavigation />
      <MembershipOpportunities />
      <PartnershipInquiry />
      <CommonQuestions />
      <FooterInformation />
    </div>;
}